import { Box, ToggleButton, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const StyledButtonsGroupContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  width: '161px',
  maxWidth: '100%',
  height: '152px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '0',
  background: '#FFF',
  borderRadius: '8px',
  color: `${theme.palette.text.primary}`,
  backgroundImage: `
    linear-gradient(
      to bottom,
      rgb(249, 249, 250) 0%,
      rgb(249, 249, 250) calc(35% - 0.25px),
      rgba(0, 0, 0, 0.23) 35%,
      rgba(0, 0, 0, 0.23) calc(35% + 0.25px),
      rgba(0,0,0,0) 36%
    )
  `,
  '&.Mui-selected': {
    color: `${theme.palette.secondary.contrastText} !important`,
    '& .MuiTypography-body2': {
      color: `${theme.palette.secondary.contrastText} !important`,
    },
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'auto',
    width: '100%',
    display: 'flex',
  },
}));

export const StyledButtonTitle = styled(Typography)(({ theme }) => ({
  color: `${theme.palette.text.primary}`,
  fontWeight: theme.typography?.h6?.fontWeight,
  marginTop: '-10px',
  fontSize: '14px !important',
  padding: '0 8px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
    paddingBottom: '0px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledButtonLabel = styled(Typography)(({ theme }) => ({
  color: `${theme.palette.text.secondary}`,
  fontSize: theme.typography?.body2?.fontSize,
  fontWeight: theme.typography?.body2?.fontWeight,
  padding: '16px 12px 4px 12px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '10px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledButtonSubtitle = styled(Typography)(({ theme }) => ({
  color: `${theme.palette.text.primary}`,
  fontSize: theme.typography?.h6?.fontSize,
  fontWeight: theme.typography?.h6?.fontWeight,
  fontStyle: 'normal',
  padding: '0px 12px 16px 12px',
  [theme.breakpoints.down('sm')]: {
    paddingTop: '0px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(0),
  },
}));

export const StyledToggleButtonContent = styled('span')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));
